import Feature from "src/js/stores/user/Feature";
import { IsochroneLayerType } from "../layer_types/IsochroneLayerType";
import { Layer, LayerGroup } from "../types";

export const ISOCHRONE_LAYER: Layer = {
  id: "ISOCHRONE",
  layerType: IsochroneLayerType,
  group: LayerGroup.PEOPLE,
  icon: "lt-layer-distance-travel-times",
  title: "Distance & travel times",
  requiredFeatureAccess: [Feature.isochroneLayer],
  toggleable: true,
  description: "Getting to specific locations",
  label: { color: "BLUE", translationKey: "map.explore.label.beta" },
  hideByDefault: true,
};
